import { useTranslation } from "react-i18next";
import type { TellescopeFormFieldBaseProps } from "../types";
import { useEffect } from "react";

export interface RedirectFieldProps extends TellescopeFormFieldBaseProps<"Redirect"> {}

export const RedirectField = ({ value, className }: RedirectFieldProps) => {
  const { t } = useTranslation("forms");

  useEffect(() => {
    if (value) {
      window.location.assign(value);
    }
  }, [value]);

  return <p className={className}>{t("Redirecting. Please wait...")}</p>;
};
